<template>
    <el-form ref="form" :inline="true" :model="searcheModel">
        <el-form-item v-for="(item, index) in fields1" :label="item.label" :key="index">
            <el-input v-if="item.type == 'input'" size="small" :placeholder="'请输入' + item.label" v-model="searcheModel[item.field]"></el-input>

            <el-select v-else-if="item.type == 'select'" size="small" v-model="searcheModel[item.field]" placeholder="请选择" :multiple='item.multiple' :clearable='item.clearable'>
                <el-option v-for="(item, key) in item.list" :label="item.label" :value="item.value" :key="key"></el-option>
            </el-select>
            
            <el-date-picker
            v-else-if="item.type == 'daterange'" 
            size="small"
            type="daterange"
            v-model="searcheModel[item.field]"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
            </el-date-picker>

            <el-date-picker
            v-else-if="item.type == 'date'" 
            size="small"
            v-model="searcheModel[item.field]"
            :type="item.date_type"
            :format="item.format"
            :value-format="item.format"
            placeholder="请选择">
            </el-date-picker>

            <component v-else-if="item.type == 'components'" :is="item.components" :ref="item.ref" :params="item.hasOwnProperty('params') ? item.params : {}" v-model="searcheModel[item.field]" @change="handleChange($event, item)" :multiple='item.multiple' :clearable='item.clearable'></component>
            
            <el-select v-if="item.type == 'select-date'" size="small" v-model="searcheModel[item.field]" placeholder="请选择">
                <el-option v-for="(item, key) in item.list" :label="item.label" :value="item.value" :key="key"></el-option>
            </el-select>

            <el-date-picker
            v-if="item.type == 'select-date'" 
            size="small"
            type="daterange"
            v-model="searcheModel[item.data_field]"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
            </el-date-picker>
        </el-form-item>
        <!-- 收起后面部分筛选条件，防止过多占用位置，为了实现展开收起就暂时复制两份同样代码处理，后续再优化 -->
        <span v-show="isCollapse">
            <el-form-item v-for="(item, index) in fields2" :label="item.label" :key="index">
                <el-input v-if="item.type == 'input'" size="small" :placeholder="'请输入' + item.label" v-model="searcheModel[item.field]"></el-input>

                <el-select v-else-if="item.type == 'select'" size="small" v-model="searcheModel[item.field]" placeholder="请选择" :multiple='item.multiple' :clearable='item.clearable'>
                    <el-option v-for="(item, key) in item.list" :label="item.label" :value="item.value" :key="key"></el-option>
                </el-select>

                <el-date-picker
                v-else-if="item.type == 'daterange'" 
                size="small"
                type="daterange"
                v-model="searcheModel[item.field]"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
                </el-date-picker>

                <el-date-picker
                v-else-if="item.type == 'date'" 
                size="small"
                v-model="searcheModel[item.field]"
                :type="item.date_type"
                :format="item.format"
                :value-format="item.format"
                placeholder="请选择">
                </el-date-picker>

                <component v-else-if="item.type == 'components'" :is="item.components" :ref="item.ref" :params="item.hasOwnProperty('params') ? item.params : {}" v-model="searcheModel[item.field]" @change="handleChange($event, item)" :multiple='item.multiple' :clearable='item.clearable'></component>

                <el-select v-if="item.type == 'select-date'" size="small" v-model="searcheModel[item.field]" placeholder="请选择">
                    <el-option v-for="(item, key) in item.list" :label="item.label" :value="item.value" :key="key"></el-option>
                </el-select>

                <el-date-picker
                v-if="item.type == 'select-date'" 
                size="small"
                type="daterange"
                v-model="searcheModel[item.data_field]"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </span>
        <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="submitSearch" :loading="loading">搜索</el-button>
            <el-button size="small" @click="resetForm(true)" :loading="loading">重置</el-button>
            <a v-if="fields2.length > 0" class="searchCollapse" @click="collapse()">{{ searchTitle }}<i :class="{ 'el-icon-fa-angle-down': isDown, 'el-icon-fa-angle-up': isUp }"></i></a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <SearchConfig v-if="is_config" :fields="group_fields" :cache_field="cache_field" @close="searchConfigClose"></SearchConfig>
            <!-- 自定义按钮插槽 -->
            <slot name="customButtons"></slot>
        </el-form-item>
    </el-form>
</template>
<style scoped>
  .el-divider-config {
    margin: 30px 0;
  }
</style>
<script>
import SearchConfig from "~/widgets/dialog/SearchConfig.vue";
import CustomerSelect from "~/widgets/CustomerSelect.vue";
import UserCascader from "~/widgets/UserCascader.vue";
import UserSelect from "~/widgets/UserSelect.vue";
import ChannelCascader from "~/widgets/ChannelCascader.vue";
import Product from "~/widgets/Product.vue";
import DistrictCascader from "~/widgets/DistrictCascader.vue";
import CustomerSelectMultiple from "~/widgets/CustomerSelectMultiple.vue";
import OrderType from "~/widgets/OrderType.vue";
import CorpSelect from "~/widgets/CorpSelect.vue";
import TagSelect from "~/widgets/TagSelect.vue";
import AuthSite from "~/widgets/AuthSite.vue";
export default{
    name: "SearchForm",

    components: {
        SearchConfig,
        CustomerSelect,
        UserCascader,
        UserSelect,
        ChannelCascader,
        Product,
        DistrictCascader,
        CustomerSelectMultiple,
        OrderType,
        CorpSelect,
        TagSelect,
        AuthSite
    },
    
    props: {
        params: {
            type: Object,
            required: false,
            value: function () {
                return {};
            }
        },

        fields: {
            type: Array,
            required: true,
        },
        
        cache_field: {
            type: String,
            required: true,
        },

        is_config: {
            type: Boolean,
            required: false,
            default: true
        },

        loading: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    
    data() {
        return {
            searcheModel: {},
            isCollapse: false,
            searchTitle: '展开',
            isDown: true,
            isUp: false,
            group_fields: [],
            all_fields: [],
            fields1: [],
            fields2: [],
            slice_num: 12,
            maskedCustomerFilters: {},
            searchConfigVisible: false,
        }
    },

    created: function () {
        this.formInit();
        // console.log('fields:', this.fields);
    },
    
    methods: {
        formInit(){
            this.searcheModel = _.clone(this.params);
            // console.log('筛选条件1：', this.fields);
            let cache_config = null;
            //读取用户缓存配置信息
            if(this.$store.getters.cache && this.$store.getters.cache.hasOwnProperty(this.cache_field)){
                cache_config = this.$store.getters.cache[this.cache_field];
            }
            
            this.group_fields = this.fields.filter(group => {
                group.children = group.children.filter(item => {
                    if (item && item.type == 'select' && (!item.list || item.list.length == 0)){
                        return false;
                    }
                    return item !== null;
                });
                return true;
            });

            // console.log('筛选条件2：', cache_config, this.group_fields, this.fields);

            this.group_fields.forEach(group => {
                let children = group.children;
                if(cache_config && cache_config.hasOwnProperty(group.field + '_check_fields')){
                    let check_fields = cache_config[group.field + '_check_fields'];
                    children = children.filter(item => {
                        return check_fields.includes(item.field);
                    });
                }
                // 将当前组的 children 数组中的所有元素添加到 all_fields 数组中
                this.all_fields = this.all_fields.concat(children);
            });

            // 在组件创建后，根据fields数组的长度进行分割
            if (this.all_fields.length > this.slice_num) {
                this.fields1 = this.all_fields.slice(0, this.slice_num); // 前10个元素
                this.fields2 = this.all_fields.slice(this.slice_num); // 剩余的元素
            } else {
                // 如果fields数组长度小于或等于10，全部放入fields1
                this.fields1 = this.all_fields;
                this.fields2 = []; // fields2为空数组
            }
        },

        // 部分搜索项隐藏展示切换
        collapse() {
            this.isCollapse = !this.isCollapse;
            if (this.isCollapse) {
                this.searchTitle = "收起";
                this.isUp = true;
                this.isDown = false;
            } else {
                this.searchTitle = "展开";
                this.isUp = false;
                this.isDown = true;
            }
        },

        //重置按钮
        resetForm() {
            // this.fields.forEach(item => {
            //     if(item.type == 'components' && this.$refs[item.ref]){
            //         console.log(item, this.$refs[item.ref], item.ref);
            //         this.$refs[item.ref].reset();
            //     }
            // });
            this.$emit("reset", true);
        },

        // 筛选查询
        submitSearch() {
            this.$emit("search", this.searcheModel);
        },

        // searchConfigShow(){
        //     this.searchConfigVisible = true;
        //     console.log('启动配置：', this.searchConfigVisible);
        // },

        searchConfigClose(){
            this.searchConfigVisible = false;
            this.resetForm();
            // console.log('关闭配置：', this.searchConfigVisible);
        },

        //change 事件调用指定函数
        handleChange(value, item) {
            // console.log('handleChange:', value, item);
            this[item.change](value, item);
        },

        getValue(value, item) {
            this.searcheModel[item.field] = value;
        },

        //联动 Cascader 选择器,切换事件,表单赋值
        changeCascaderLast(value, item){
            if (value.length > 0) {
                // 取得最后一级部门作为所属部门
                this.searcheModel[item.field] = value[value.length - 1];
            } else {
                this.searcheModel[item.field] = "";
            }
        },

        //业务员姓名远程搜索组件赋值label
        changeObjLabel(value, item) {
            this.searcheModel[item.field] = value.label;
        },

        //业务员姓名远程搜索组件赋值value
        changeObjValue(value, item) {
            let exactField = '';
            if (item.components === 'CustomerSelect') {
                if (item.field === 'customer_name') {
                    exactField = 'customer_id';
                } else if (item.field === 'name') {
                    exactField = 'id';
                }
            }

            if (exactField && value && value.sensitive_masked) {
                this.searcheModel[item.field] = '';
                this.searcheModel[exactField] = value.query_value;
                this.maskedCustomerFilters[item.field] = {
                    field: exactField,
                    value: value.query_value,
                };
                return;
            }

            let maskedFilter = this.maskedCustomerFilters[item.field];
            if (maskedFilter && this.searcheModel[maskedFilter.field] === maskedFilter.value) {
                this.searcheModel[maskedFilter.field] = '';
            }
            delete this.maskedCustomerFilters[item.field];
            this.searcheModel[item.field] = value.value;
        },

        //地区联动 Cascader 级联选择器,切换事件,表单赋值
        changeDistrict(value, item) {
            this.searcheModel.province_id = parseInt(value[0]);
            this.searcheModel.city_id = parseInt(value[1]);
            this.searcheModel.district_id = parseInt(value[2]);
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/widgets/SearchForm.vue